import React from "react";
import { ClinicLocationIcon } from "../../../../components/Icons";
import {
  ILocationItemResponse,
} from "../../../../services/edit-hospital-location/edit-hospital-location.interface";

interface ReviewLocationCardProps {
  location: ILocationItemResponse | null;
  homeLocationName?: string;
  homeLocationId?: string;
}

export const ReviewLocationCard = ({
  location,
  homeLocationName,
  homeLocationId,
}: ReviewLocationCardProps) => {
  const displayName = location?.locationName || homeLocationName || "";
  const isNotHomeHospital = location &&
    homeLocationId &&
    location.idLocation !== homeLocationId;

  return (
    <div className="flex flex-col gap-2 bg-taupe-15 rounded-lg p-3">
      <div className="flex gap-2 items-start">
        <div className="pt-0.5 shrink-0">
          <ClinicLocationIcon width={20} height={20} color="#262626" />
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-sm text-light-black leading-5">
            GoodVets {displayName}
          </span>
          {location?.address && (
            <span className="text-xs text-light-black leading-[18px]">
              {location.address}
            </span>
          )}
        </div>
      </div>
      {isNotHomeHospital && (
        <div className="bg-taupe-50 rounded px-4 py-1
          flex items-center justify-center"
        >
          <span className="text-xs text-light-black leading-3">
            This is not your Home Hospital
          </span>
        </div>
      )}
    </div>
  );
};
